/**
 * @ngdoc Controller
 * @name BaseController
 */

(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('BaseController', BaseController);

    /**
     * @constructor
     * @ngInject
     */
    function BaseController($rootScope, $scope, InstallationsService, UserService, VrmLangService, $timeout, locale, ApiService, vrmUserAccessLevel, vrmConfig, vrmNotificationsService, vrmNotificationType) {
        VrmLangService.getLang().then(function(lang) {
            VrmLangService.setLangLocal(lang);
        });

        $scope.loading = true;
        $scope.loadingNavBar = true;
        $scope.installations = [];
        $scope.sharedInstallations = [];
        $scope.navInstallations = [];
        $scope.myInstallations = [];
        $scope.customerInstallations = [];
        $scope.activeInstallation = null;

        $rootScope.user = null;
        $rootScope.userState = {
            isDemo: false,
            isShare: ApiService.isShare(),
            isAdmin: false,
            isFullAdmin: false,
            isRestrictedAdmin: false
        };

        function loadUserState() {
            if (!$rootScope.userState.isShare) {
                UserService.getUser().then(function() {
                    if (UserService.user)
                    {
                        window.dataLayer.push({ event: 'versionjs', version:  window.__version, user: UserService.user.id  });
                        $rootScope.user = UserService.user;
                        $rootScope.userState.isDemo = $rootScope.user.accessLevel == vrmUserAccessLevel.DEMO;
                        $rootScope.userState.isAdmin = $rootScope.user.accessLevel === vrmUserAccessLevel.ADMIN || $rootScope.user.accessLevel === vrmUserAccessLevel.RESTRICTED_ADMIN;
                        $rootScope.userState.isFullAdmin = $rootScope.user.accessLevel === vrmUserAccessLevel.ADMIN;
                        $rootScope.userState.isRestrictedAdmin = $rootScope.user.accessLevel === vrmUserAccessLevel.RESTRICTED_ADMIN;
                    }
                });
            }
            window.dispatchEvent(new CustomEvent('user_state_changed')); //Used by vrm-2fa-non-admin-banner
        }

        const userAccessChangedListener = $rootScope.$on('user:access_changed', loadUserState);
        loadUserState();

        function updateUserState(user) {
            $rootScope.user = user;
        }
        function manageMutedErrorPaths(user){
            const installationPath = /\/users\/[\d]+\/installations/;

            if (user.accessLevel === vrmUserAccessLevel.SET_UP_MFA){
                ApiService.errorMutedPaths.add(installationPath.source)
            } else {
                ApiService.errorMutedPaths.delete(installationPath.source)
            }
        }
        function onUserLoaded(event, user){
            updateUserState(user);
            manageMutedErrorPaths(user);
        }
        const userLoadedListener = $rootScope.$on('user:loaded', onUserLoaded);

        var reload = null;
        var currentTimeout = vrmConfig.refreshInstallationsInterval || 60 * 1000;
        var scheduleInstallationReload = function() {
            // Skip background polling in embedded remote console mode for performance
            if ($rootScope.remoteConsoleEmbeddedMode) {
                return;
            }
            
            reload = $timeout(function () {
                // Reschedule if the viewport is obstructed or the browser has gone offline
                if (document.hidden || !navigator.onLine)
                {
                    scheduleInstallationReload();
                    currentTimeout = 1000;
                    return;
                }

                currentTimeout = vrmConfig.refreshInstallationsInterval || 60 * 1000;
                InstallationsService.reload();
                InstallationsService.loading.then(scheduleInstallationReload, scheduleInstallationReload);
            }, currentTimeout);
        };

        function onInstallationsChanged() {
            const installations = InstallationsService.installations;
            // Filter installation collection on owner yes / no, be careful, if a site is shared, it should show up in my installations instead of customer installations
            $scope.myInstallations = _.filter(installations, {owner: true, shared: false});
            $scope.customerInstallations = _.filter(installations, {owner: false, shared: false});
            $scope.sharedInstallations = _.filter(installations, {shared: true});
            $scope.navInstallations = $scope.myInstallations;
            $scope.installations = _.filter(installations, {shared: false});

            // Reload installations periodically (skip in embedded remote console mode)
            if (reload === null && !$rootScope.remoteConsoleEmbeddedMode)
                scheduleInstallationReload();
        }
        const installationUpdatedListener = $rootScope.$on('installations:updated', onInstallationsChanged);
        onInstallationsChanged();

        // For admins and dealers: keep track of active installation to show it in the menu
        function onActiveInstallationChanged() {
            if (!InstallationsService.activeInstallation) {
                $scope.activeInstallation = null;
                return;
            }
            const externalSite = InstallationsService.installations.findIndex(site => site.id === InstallationsService.activeInstallation.id) === -1;
            $scope.activeInstallation = {
                ...InstallationsService.activeInstallation,
                _externalSite: externalSite
            }
        }
        const activeInstallationChangedListener = $rootScope.$on('activeInstallation:changed', onActiveInstallationChanged);
        onActiveInstallationChanged();

        $scope.$on('$destroy', function() {
            $timeout.cancel(reload);

            // Remove listeners
            userLoadedListener();
            userAccessChangedListener();
            installationUpdatedListener();
            activeInstallationChangedListener();
        });


        InstallationsService.loadingNavBar.then(function() {
            $scope.loadingNavBar = false;
        })

        InstallationsService.loading.then(function() {
            $scope.loading = false;
            $scope.loadingNavBar = false;
        })
    }

})();
